<template>
  <v-tooltip top color="transparent" max-width="280">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" color="#7513BF">
        mdi-information
      </v-icon>
    </template>
    <v-card color="black" class="white--text pa-3 text-center">
      {{ text }}
    </v-card>
  </v-tooltip>
</template>

<script>
export default {
  name: "ToolTip",
  props: {
    text: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
